// Hex geometry in axial coordinates {q, r}, flat-top hexes. Screen position: x = 1.5·q,
// y = √3·(r + q/2) (times the hex size). Rotating 180° maps (q, r) → (−q, −r).

export interface Hex {
  q: number;
  r: number;
}

export const DIRECTIONS: Hex[] = [
  { q: 1, r: 0 }, { q: 1, r: -1 }, { q: 0, r: -1 },
  { q: -1, r: 0 }, { q: -1, r: 1 }, { q: 0, r: 1 },
];
export const DIRECTION_NAMES = ['SE', 'NE', 'N', 'NW', 'SW', 'S'];  // DIRECTIONS order

export function hexEq(a: Hex | null, b: Hex | null): boolean {
  return !!a && !!b && a.q === b.q && a.r === b.r;
}

export function distance(a: Hex, b: Hex): number {
  return (Math.abs(a.q - b.q) + Math.abs(a.r - b.r) + Math.abs(a.q + a.r - b.q - b.r)) / 2;
}

export function neighbors(h: Hex): Hex[] {
  return DIRECTIONS.map(d => ({ q: h.q + d.q, r: h.r + d.r }));
}

export function mirror(h: Hex): Hex {
  return { q: -h.q || 0, r: -h.r || 0 };
}

export function ahead(h: Hex, facing: number): Hex {
  const d = DIRECTIONS[facing];
  return { q: h.q + d.q, r: h.r + d.r };
}
